import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaHome, FaCaretDown, FaCog, FaSignOutAlt } from "react-icons/fa";
import { useMsal } from "@azure/msal-react";
import { silentRequest } from "../../../msalconfig";
import "./header.css";
import WhygreneLogo from "../../../assets/images/WG_4dot_1.png";
// import WhygreneLogo from "../../../assets/images/Quest_whygrene_1.png";
import { PYTHON_API_BASE_URL } from "../../../services/api/apiConstants";
import { useNavigation } from "../../../contexts/NavigationContext";
import { clearLocalAuthState } from "../../../utils/clearLocalAuthState";

const Header = ({ header, userProfile }) => {
  const [userName, setUserName] = useState("Loading...");
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const navigate = useNavigate();
  const [title, setTitle] = useState();
  const location = useLocation(); // Use location to get current path
  const dropdownRef = useRef(null);
  const { instance } = useMsal();
  const { clearNavigation, setTimeSeriesFileName } = useNavigation();
  const jobTitle = sessionStorage.getItem("jobTitle");
  const tokenRef = useRef(sessionStorage.getItem("accessToken"));

  useEffect(() => {
    if (header) {
      setTitle(header.name);
    }
  }, [header]);

  useEffect(() => {
    const fetchUserDetails = async () => {
      let token = tokenRef.current;
      if (!token) {
        // In dev/hot-reload, token may not be in sessionStorage yet. Ask MSAL for one.
        const account =
          instance.getActiveAccount() || instance.getAllAccounts()[0];
        if (account) {
          try {
            const tokenRes = await instance.acquireTokenSilent({
              ...silentRequest,
              account,
            });
            token = tokenRes.accessToken;
            tokenRef.current = token;
            sessionStorage.setItem("accessToken", token);
          } catch (e) {
            console.warn(
              "Header: failed to acquire token silently; skipping user-name fetch",
              e,
            );
            return;
          }
        }
      }

      if (!token) return; // still no token, abort
      try {
        const response = await fetch(`${PYTHON_API_BASE_URL}/get-user-name/`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "X-User-ID": sessionStorage.getItem("UserID") || "",
          },
        });

        if (!response.ok) {
          throw new Error(
            `Error fetching user details: ${response.statusText}`,
          );
        }

        const user = await response.json();

        if (user) {
          setUserName(`${user.first_name} ${user.last_name}`);
          if (user.id) {
            sessionStorage.setItem("UserID", user.id);
          }
        }
      } catch (error) {
        console.error("Error fetching user details:", error);
      }
    };

    fetchUserDetails();
  }, [instance]);

  const toggleDropDown = () => {
    setDropdownVisible(!dropdownVisible);
  };

  const logOut = () => {
    setTimeSeriesFileName(null);
    
    // Clear navigation context (resets sidenav to Tier 1)
    clearNavigation();

    clearLocalAuthState();

    sessionStorage.clear();
    navigate("/");
    instance.logoutRedirect();
  };

  const goToSettings = () => {
    setDropdownVisible(false);
    navigate("/employee-settings");
  };

  const goToHome = () => {
    if(jobTitle === "Organization Admin") navigate("/branchhomepage");
    if(jobTitle === "Branch Admin") navigate("/employees");
    if(jobTitle === "Employee") navigate("/employeehomepage");
    if(jobTitle === "Customer") navigate("/microgrid-page-design");
    
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);
    

  return (
    <header
      className="header d-flex justify-content-between align-items-center"
    >
      <div className="left-side d-flex align-items-center">
        <img
          className="img-fluid logo"
          src={WhygreneLogo}
          alt="whygrene"
          width="175px"
          height="auto"
        />
        <h2 className="header-title ml-3">{title}</h2>
      </div>
      <div className="right-side d-flex align-items-center">
        <button onClick={goToHome} className="home-icon" title="Home">
          <FaHome size={20} style={{ color: "#333", marginRight: "15px" }} />
        </button>
        <div className="position-relative d-inline-block" ref={dropdownRef}>
          <button onClick={toggleDropDown} className="username">
            {userName}
            <FaCaretDown className="ml-2" />
          </button>
          {dropdownVisible && (
            <div className="dropdown-menu">
              <button onClick={goToSettings} className="dropdown-item">
                <FaCog className="mr-2" /> Settings
              </button>
              <button onClick={logOut} className="dropdown-item">
                <FaSignOutAlt className="mr-2" /> Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
